__turbopack_context__.v({
  "fieldset": "PaymentMethodSelection-module__nnKuFa__fieldset",
  "headingMargin": "PaymentMethodSelection-module__nnKuFa__headingMargin",
  "labelContent": "PaymentMethodSelection-module__nnKuFa__labelContent",
  "paymentMethodIcon": "PaymentMethodSelection-module__nnKuFa__paymentMethodIcon",
  "radio": "PaymentMethodSelection-module__nnKuFa__radio",
  "radioLabel": "PaymentMethodSelection-module__nnKuFa__radioLabel",
  "skeletonContainer": "PaymentMethodSelection-module__nnKuFa__skeletonContainer",
});
